import { Carousel } from '@mantine/carousel';
import { ActionIcon, Menu, Switch } from '@mantine/core';
import Icon from '../Icon/Icon';
import { ParamType } from '../PopSlider/PopSlider';
import Slider from '../Slider/Slider';
import { Content, Header, Image, Reset, Wrapper } from './BackDropPopover.style';

export type BackDropPopoverProps = {
  holodeck: IHolodeckState;
  backdrops: IShader[];
  onSet: (paramType: ParamType, value: number | string | boolean) => void;
};

export function BackDropPopover(props: BackDropPopoverProps) {
  const { holodeck, backdrops } = props;
  const { backdropEnabled, backdropGrainIntensity, backdropId } = holodeck;

  function onReset() {
    props.onSet('intensity', 0);
    props.onSet('color', 0);
    props.onSet('enabled', false);
  }

  function onSetSlider(newValue: number) {
    props.onSet('intensity', newValue);
  }

  function onToggle() {
    props.onSet('enabled', !backdropEnabled);
  }

  function onCarouselChange(index: number) {
    props.onSet('color', index + 1);
  }

  function renderBackdrop(backdrop: IShader) {
    return (
      <Carousel.Slide key={backdrop.id}>
        <Image src={backdrop.thumbUrl} />
      </Carousel.Slide>
    );
  }

  function renderBackdrops() {
    return backdrops.map((backdrop: IShader) => renderBackdrop(backdrop));
  }

  return (
    <Wrapper className='BackDropPopover-wrapper' data-testid='BackDropPopover-wrapper'>
      <Menu>
        <Menu.Target>
          <ActionIcon size='lg' variant='subtle' color='blue'>
            <Icon name='IconPhoto' size={20} color='#74c0fc' />
          </ActionIcon>
        </Menu.Target>
        <Menu.Dropdown style={{ position: 'absolute', transform: 'translate(-125px, 40px)' }}>
          <Content>
            <Header>Backdrop</Header>
            <Reset>
              <Icon color='#ffffff44' name='IconRotate' onClick={onReset}></Icon>
            </Reset>

            <Switch onChange={onToggle} label='Backdrop on' checked={backdropEnabled} />
            <Carousel
              orientation='vertical'
              height={180}
              withIndicators
              withControls
              initialSlide={backdropId - 1}
              onSlideChange={onCarouselChange}
            >
              {renderBackdrops()}
            </Carousel>

            <Slider
              step={0.01}
              min={0}
              max={1}
              value={backdropGrainIntensity}
              onChangeEnd={onSetSlider}
            />
          </Content>
        </Menu.Dropdown>
      </Menu>
    </Wrapper>
  );
}

export default BackDropPopover;
